import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, Button} from 'reactstrap';
import axios from "axios";
import {serverPath} from "../../common";

class EditTextData extends Component {

    constructor(props) {
        super(props);

        this.state = {
            problem: props.problem
        };

        this.saveChanges = this.saveChanges.bind(this);
    }

    saveChanges() {
        var params = new FormData();
        params.append('action', 'editTextData');
        params.append('problem', JSON.stringify(this.state.problem));
        axios.post(serverPath + "problemsService.php", params)
            .then((response) => {
            this.props.closeModalHandler(this.state.problem);
        });
    }

    handleChange = event => {
        const {name, value} = event.target
        const updatedControls = {
            ...this.state.problem
        };
        updatedControls[name] = value;
        this.setState({ problem: updatedControls });
    }

    render() {
        return (
            this.state.problem ?
            <Modal isOpen={this.props.isOpen} toggle={() => this.props.closeModalHandler(null)} className="middleSizeModal">
                <ModalHeader toggle={() => this.props.closeModalHandler(null)}>
                    <h4> Izmena tekstualnih podataka  </h4>
                </ModalHeader>
                <ModalBody className="">
                    <div className="form-group">
                        <label htmlFor="index">Redni broj zadatka</label>
                        <input className="form-control"
                               id="index"
                               name="index"
                               type="number"
                               value={this.state.problem.index}
                               onChange={this.handleChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="name">Naslov zadatka</label>
                        <input
                            className="form-control"
                            id="name"
                            name="name"
                            type="text"
                            value={this.state.problem.name}
                            onChange={this.handleChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text">Tekst zadatka</label>
                        <textarea
                            className="form-control"
                            id="text"
                            name="text"
                            rows="20"
                            value={this.state.problem.text}
                            onChange={this.handleChange}>
                        </textarea>
                    </div>
                    <Button onClick={this.saveChanges}> Sačuvaj promene </Button>
                    <Button onClick={() => this.props.closeModalHandler(null)}> Odustani </Button>
                </ModalBody>
            </Modal>
                : null
        );
    }
}

export default EditTextData;